import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';

export const SORT_DEFINITIONS = [
  {
    value: 'desc',
    label: 'Newest first',
    Icon: ArrowDownOutlined,
    iconClass: 'text-indigo-500',
    textClass: 'text-indigo-600',
  },
  {
    value: 'asc',
    label: 'Oldest first',
    Icon: ArrowUpOutlined,
    iconClass: 'text-emerald-500',
    textClass: 'text-emerald-600',
  },
];

export const LOADING_STATUS = [1, 4, 6, 8];
